module.exports = {
	"Play": "Възпроизвеждане",
	"Pause": "Пауза",
	"Current Time": "Текущо време",
	"Duration Time": "Продължителност",
	"Remaining Time": "Оставащо време",
	"Stream Type": "Тип на потока",
	"LIVE": "НА ЖИВО",
	"Loaded": "Заредено",
	"Progress": "Прогрес",
	"Fullscreen": "Цял екран",
	"Non-Fullscreen": "Спиране на цял екран",
	"Mute": "Без звук",
	"Unmute": "Със звук",
	"Playback Rate": "Скорост на възпроизвеждане",
	"Subtitles": "Субтитри",
	"subtitles off": "Спряни субтитри",
	"Captions": "Аудио надписи",
	"captions off": "Спряни аудио надписи",
	"Chapters": "Глави",
	"You aborted the media playback": "Спряхте възпроизвеждането на видеото",
	"A network error caused the media download to fail part-way.": "Грешка в мрежата провали изтеглянето на видеото.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "Видеото не може да бъде заредено заради проблем със сървъра или мрежата или защото този формат не е поддържан.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Възпроизвеждането на видеото беше прекъснато заради проблем с файла или защото видеото използва опции които браузърът Ви не поддържа.",
	"No compatible source was found for this media.": "Не беше намерен съвместим източник за това видео."
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-video-player/lang/bg.json
// module id = 241
// module chunks = 81